import Dialog from '@mui/material/Dialog';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import Button from '../atoms/Button';

const SacramentConfirmation = ({
  onClose,
  open,
  sacramentType,
  updateSacraments,
}) => {
  const { levelSelection } = useParams();

  const handleClose = () => {
    onClose();
  };

  let title;
  let msg;
  if (sacramentType === 'baptism' && levelSelection === '2') {
    title = 'Update Baptism';
    msg = (
      <div className='mb-4'>
        You are about to update BAPTISM information for all Level-
        {levelSelection} students with the following information:
        <ul className='mt-4'>
          <li>Church: OLPS</li>
          <li>Date: {dayjs().format('DD MMMM YYYY')}</li>
        </ul>
      </div>
    );
  } else if (sacramentType === 'recon' && levelSelection === '2') {
    title = 'Update First Reconciliation';
    msg = (
      <div className='mb-4'>
        You are about to update FIRST RECONCILIATION information for all Level-
        {levelSelection} students with the following information:
        <ul className='mt-4'>
          <li>Church: OLPS</li>
          <li>Date: {dayjs().format('DD MMMM YYYY')}</li>
        </ul>
      </div>
    );
  } else if (sacramentType === 'comm' && levelSelection === '3') {
    title = 'Update First Holy Communion';
    msg = (
      <div className='mb-4'>
        You are about to update FIRST HOLY COMMUNION information for all Level-
        {levelSelection} students with the following information:
        <ul className='mt-4'>
          <li>Church: OLPS</li>
          <li>Date: {dayjs().format('DD MMMM YYYY')}</li>
        </ul>
      </div>
    );
  }

  return (
    <Dialog onClose={handleClose} open={open} maxWidth='sm' fullWidth={true}>
      <div className='p-4' data-cy='sacrament-modal'>
        <h1 className='my-4 text-2xl font-bold' data-cy='sacrament-modal-title'>
          {title}
        </h1>
        {msg}
        <div className='text-center'>
          <Button testid='sacrament-proceed-button' callback={updateSacraments}>
            Proceed
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default SacramentConfirmation;
